import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class FormAdditionalServiceRegistrationService {

  constructor(private http: HttpClient) { }

  apiInsert(body): Observable<any> {
    return this.http.post<any>(environment.endpointBackend + '/api/line/insert/additionalServiceRegistration', body).pipe(
      map(
        payload => {
          switch (payload.response_code) {
            case ('40000'):
              return payload
            default:
              return null
          }
        }
      )
    )
  }

  
}